export default {
    message: {
        tiers: {
            t1: {
                label: "Frittstående",
                desc: "<p>Samlet tilgang til alle virtuelle, nettbaserte og SaaS-apper, beskytter brukere, apper og data med komplett kontekstuell sikkerhetskontroll.</p><p>Tilbyr VPN-fri proxy og SSO til nett-, SaaS-, virtuelle og mobile apper, samt beskyttelse mot ondsinnet innhold, nøkkelloggere og skjermfangstskadevare.</p>"
            },
            t2: {
                label: "Workspace Premium",
                desc: "<p>Komplett løsning for medarbeidere som trenger en fullstendig digital arbeidsplass med granulær sikkerhet, men ikke trenger virtuelle apper og stasjonære maskiner.</p><p>Inkluderer Workspace Standard-funksjonalitet, pluss avanserte sikkerhetskontroller for SaaS og web, enhetlig Endpoint Management og Content Collaboration Premium.</p>"
            },
            t3: {
                label: "Workspace Premium Plus",
                desc: "<p>Omfattende arbeidsplassløsning med muligheter for hybrid distribusjon av Citrix Virtual Apps and Desktops.</p><p>Inkluderer Workspace Premium-funksjonalitet, pluss et skyadministrasjonsalternativ for Citrix Virtual Apps and Desktops.</p>"
            }
        }
    }
}